import { MessageCircle, Mail } from "lucide-react";
import { SITE } from "@/config/site";

const ITEMS = [
  { icon: MessageCircle, label: "WhatsApp", href: SITE.whatsapp, testid: "float-whatsapp", external: true },
  { icon: Mail, label: "Email us", href: `mailto:${SITE.email}`, testid: "float-email", external: false },
];

export const FloatingContacts = () => {
  return (
    <div className="fixed bottom-6 right-5 z-40 flex flex-col gap-3 md:bottom-8 md:right-8" data-testid="floating-contacts">
      {ITEMS.map((it, i) => {
        const Icon = it.icon;
        const isWa = it.testid === "float-whatsapp";
        return (
          <a
            key={it.testid}
            href={it.href}
            data-testid={it.testid}
            aria-label={it.label}
            {...(it.external ? { target: "_blank", rel: "noreferrer" } : {})}
            className={`bwt-pop group relative flex h-12 w-12 items-center justify-center rounded-full text-white shadow-lg transition-colors duration-300 md:h-14 md:w-14 ${
              isWa ? "bg-[#25D366] shadow-[#25D366]/30 hover:bg-[#1ebe5b]" : "bg-navy shadow-navy/30 hover:bg-sky"
            }`}
            style={{ animationDelay: `${0.5 + i * 0.12}s` }}
          >
            <Icon className="h-5 w-5 shrink-0 md:h-6 md:w-6" />
            <span className="pointer-events-none absolute right-full mr-3 whitespace-nowrap rounded-full bg-navy px-3 py-1.5 text-xs font-semibold text-white opacity-0 transition-opacity duration-300 group-hover:opacity-100">
              {it.label}
            </span>
          </a>
        );
      })}
    </div>
  );
};
